import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
import '@/styles/index.less'
import router from '@/router'
import { store } from '@/stores/store'
import dayjs from 'dayjs'
import { ConfigProvider } from 'antd-mobile'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import { getAntLangFile } from '@/utils/i18n'
import { AliveScope } from 'react-activation'
import utils from '@/utils/utils'
import common from '@/utils/common'
import exchangeTokenUtil from '@/utils/token'
import localStorage from './utils/localStorage'
import 'virtual:svg-icons-register'

const { getLocalStorage } = localStorage
const { getUrlAllParams, initVConsole } = utils
const {
  timeLooperRequest,
  getApiByAppEnv,
  checkCorpChange,
  changeAlbumPageTitle,
} = common

// 判断是否是生产环境的条件，打包是生产环境，或者app传的环境是生产环境
const isProduction =
  NODE_ENV === 'production' || getLocalStorage('resEnv') === 'production'

if (!isProduction) {
  initVConsole()
}

getUrlAllParams()
getApiByAppEnv()
checkCorpChange()
changeAlbumPageTitle()

dayjs.extend(quarterOfYear)
exchangeTokenUtil.startExchangeLoop()
timeLooperRequest()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <ConfigProvider locale={getAntLangFile()}>
      <AliveScope>
        <RouterProvider router={router}></RouterProvider>
      </AliveScope>
    </ConfigProvider>
  </Provider>,
)
